export const possibleTypes = {
    "NavigationItemResult": [
        "NavigationItem",
        "UnauthorizedError"
    ],
    "Error": [
        "UnauthorizedError",
        "NotFoundError",
        "ServiceUnavailableError",
        "ForbiddenError"
    ],
    "TileResult": [
        "Tile",
        "UnauthorizedError",
        "NotFoundError"
    ],
    "OrganizationResult": [
        "Organization",
        "UnauthorizedError",
        "NotFoundError"
    ],
    "TagResult": [
        "Tag",
        "UnauthorizedError"
    ],
    "MailResult": [
        "Mail",
        "UnauthorizedError",
        "ServiceUnavailableError"
    ],
    "MoodleResult": [
        "Moodle",
        "UnauthorizedError",
        "ServiceUnavailableError"
    ],
    "UserConfigResult": [
        "UserConfig",
        "UnauthorizedError",
        "NotFoundError"
    ],
    "TileCreateResult": [
        "Tile",
        "UnauthorizedError",
        "NotFoundError"
    ],
    "TileUpdateResult": [
        "Tile",
        "UnauthorizedError",
        "NotFoundError",
        "ForbiddenError"
    ],
    "TileDeleteResult": [
        "Response",
        "UnauthorizedError",
        "NotFoundError",
        "ForbiddenError"
    ],
    "TagUpdateResult": [
        "Tag",
        "UnauthorizedError",
        "NotFoundError"
    ],
    "LinkCreateResult": [
        "Link",
        "UnauthorizedError"
    ],
    "LinkUpdateResult": [
        "Link",
        "UnauthorizedError",
        "NotFoundError",
        "ForbiddenError"
    ],
    "LinkDeleteResult": [
        "Response",
        "UnauthorizedError",
        "NotFoundError",
        "ForbiddenError"
    ],
    "TileUsageIncrementResult": [
        "Response",
        "UnauthorizedError",
        "NotFoundError"
    ],
    "UserConfigUpsertResult": [
        "UserConfig",
        "UnauthorizedError"
    ]
}